import React, { Component } from 'react'
import { i18nTranslate } from 'src/utils'
import { Button, Modal } from 'react-bootstrap'
import { customerContainer } from 'src/models'
import { IS_BROWSER, deleteFromSessionStorage } from 'config/appConfig'
import { languageAbbreviation } from 'src/views/pages/LoginCallback/fixture'
class SponsorChangePopUp extends Component {
  constructor(props) {
    super(props)
  }

  /**
   * @description used to check and remove items in session storage
   * @date 10/20/2023 - 1:45:03 PM
   *
   */
  goToHomePage = () => {
    const { isHomeMarket = false, isFromAccountProfile = false } = this.props
    if (!isHomeMarket && !isFromAccountProfile) {
      if (IS_BROWSER) {
        let homeCountry = ''
        customerContainer?.profileResponse?.accounts?.properties?.forEach(
          element => {
            if (element.attributeId === 'countryCode') {
              homeCountry = element.value
            }
          }
        )
        homeCountry = homeCountry?.toLowerCase() || 'us'
        const preferredLanguage =
          customerContainer?.profileResponse?.customProperties
            ?.preferredLanguage || 'English'
        const languageKey = languageAbbreviation?.[preferredLanguage] || 'en'
        window.location.href = `/${homeCountry}/${languageKey}/myaccount/accounttype`
      }
    } else {
      deleteFromSessionStorage('conv-sponsor')
      deleteFromSessionStorage('switchsponsor')
      deleteFromSessionStorage('mem')
      this.props?.history?.push('/')
    }
  }

  render() {
    const {
      isToShowPopUp = false,
      sponsorActive = false,
      isHomeMarket = false,
      IsFeatureEnabled = false,
      isFromAccountProfile = false,
      isSameSponsor = false,
      isToShowRetailErrorPopUp = false,
      isToShowBrandAffiliatePopup = false,
      sponsorName = '',
      isShowcaseBASponsorChangeError = false,
      isBrandAffiliate = false,
    } = this.props
    const displayedMessage = () => {
      if (isFromAccountProfile === true) {
        switch (true) {
          case isSameSponsor:
            const name = `${sponsorName?.firstName || ''} ${
              sponsorName?.lastName || ''
            }`
            return (
              name +
              i18nTranslate(
                'sponsorChange.alreadySponsored',
                ' is already your sponsoring Brand Affiliate! No change is needed here.'
              )
            )
          case isToShowBrandAffiliatePopup:
            return i18nTranslate(
              'sponsorChange.alreadyBA',
              "It looks like you are already a brand affiliate! This means you don't need to convert your account."
            )
          case isToShowRetailErrorPopUp:
            return i18nTranslate(
              'sponsorChange.cantswitch',
              "It looks like you aren't a retail customer, which means we aren't able to switch your sponsoring Brand Affiliate."
            )
          default:
            break
        }
      } else if (isShowcaseBASponsorChangeError === true) {
        switch (true) {
          case !isHomeMarket:
            return i18nTranslate(
              'sponsorChange.nonHomeMarket',
              "It looks like you received this link with the incorrect home market selected, which means we aren't able to switch your sponsoring Brand Affiliate at this time"
            )
          case isBrandAffiliate:
            return i18nTranslate(
              'sponsorChange.downgrade',
              'This feature is not available for your current account type.'
            )
          case !sponsorActive:
            return i18nTranslate(
              'sponsorChange.inCorrectUrl',
              "It looks like the link you used is broken, which means we can't help you here."
            )
          default:
            return i18nTranslate(
              'sponsorChange.cantswitch',
              "It looks like you aren't a retail customer which means we aren't able to switch your sponsoring affiliate."
            )
        }
      } else {
        switch (true) {
          case isToShowBrandAffiliatePopup:
            return i18nTranslate(
              'sponsorChange.alreadyBA',
              "It looks like you are already a brand affiliate! This means you don't need to convert your account."
            )
          case !isHomeMarket:
            return i18nTranslate(
              'sponsorChange.nonHomeMarket',
              "It looks like you received this link with the incorrect home market selected, which means we aren't able to switch your sponsoring Brand Affiliate at this time"
            )
          case !IsFeatureEnabled:
            return i18nTranslate(
              'sponsorChange.flagOff',
              'This feature is not available for you at this time.'
            )
          case !sponsorActive:
            return i18nTranslate(
              'sponsorChange.inCorrectUrl',
              "It looks like the link you used is broken, which means we can't help you here."
            )
          default:
            return i18nTranslate(
              'sponsorChange.downgrade',
              'This feature is not available for your current account type.'
            )
        }
      }
    }
    return (
      <Modal show={isToShowPopUp} className="sponsor-change">
        <Modal.Body>
          <h3>
            {isSameSponsor
              ? i18nTranslate('sponsorChange.easy', 'Well this is easy!')
              : i18nTranslate('sponsorChange.hmm', 'Hmm...')}
          </h3>
          <p>{displayedMessage()}</p>
          <p>
            {!isToShowBrandAffiliatePopup &&
              i18nTranslate(
                'sponsorChange.further',
                'If you have further questions please reach out to your local customer service or the person who sent this link to you.'
              )}
          </p>
          <Button
            data-testid="qa-sponsorchange"
            className="mt-3 qa-sponsorchange"
            variant="primary"
            type="submit"
            onClick={() => {
              this.goToHomePage()
            }}
            block>
            {isHomeMarket || isFromAccountProfile
              ? i18nTranslate('sponsorChange.gotohomepage', 'Go to home page')
              : i18nTranslate(
                  'sponsorChange.gotomymarket',
                  'Go to home market'
                )}
          </Button>
        </Modal.Body>
      </Modal>
    )
  }
}

export default SponsorChangePopUp
export { SponsorChangePopUp }
